var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStopLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C2.5 8.84315 3.84315 7.5 5.5 7.5H14.5C16.1569 7.5 17.5 8.84315 17.5 10.5C17.5 12.1569 16.1569 13.5 14.5 13.5H5.5C3.84315 13.5 2.5 12.1569 2.5 10.5Z",
    stroke: "#6E7882"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 8,
    height: 1,
    fill: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopLabel);
export default __webpack_public_path__ + "static/media/icon-stop-label.010935acd82581eeb8aab67d7434fe0d.svg";
export { ForwardRef as ReactComponent };